var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.$t('message.value', { value: 'This is an example of content translation' }))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }